import { makeAutoObservable } from 'mobx'
import type { IResponseWorkflowExecutionItem } from 'entities/Workflow/api/types'
import type { IResponseGetConversationsByIdStatesItem } from 'entities/Conversation'

export class WorkflowExecution {
  private _id = ''
  private _workflow_name = ' '
  private _is_pause_supported = false
  private _paused_at: string | null = null
  private _pause_options: IResponseWorkflowExecutionItem['pause_options'] | null = null

  // state
  private _status: IResponseGetConversationsByIdStatesItem['status'] | null = null

  private readonly _originExecution: IResponseWorkflowExecutionItem | null
  private readonly _originState: IResponseGetConversationsByIdStatesItem

  private _loading = false

  constructor(
    state: IResponseGetConversationsByIdStatesItem,
    execution: IResponseWorkflowExecutionItem | null
  ) {
    makeAutoObservable(this)

    this._originExecution = execution
    this._originState = state

    this.syncOrigin(state, execution)
  }

  syncOrigin(
    state: IResponseGetConversationsByIdStatesItem,
    item: IResponseWorkflowExecutionItem | null
  ) {
    this._id = state.initiator_id
    this._status = state.status

    if (item) {
      this._is_pause_supported = item.is_pause_supported
      this._workflow_name = item.workflow_name
      this._paused_at = item.paused_at
      this._pause_options = item.pause_options
    }
  }

  get id() {
    return this._id
  }

  get isExecutionExist() {
    return Boolean(this._originExecution)
  }

  get isPauseSupported() {
    if (!this._originExecution) return false

    return this._is_pause_supported
  }

  get isLockPaused() {
    return this._status === 'Paused'
  }

  get isLock() {
    return this._status === 'Active'
  }

  get currentStatus() {
    if (this.isLockPaused) return 'paused'
    if (this.isExecutionExist) return 'active'

    return 'error'
  }

  get workflowName() {
    return this._workflow_name
  }

  get pausedAt() {
    return this._paused_at
  }

  get pauseOptions() {
    if (!this._pause_options) {
      return {
        timeout: 0,
      }
    }

    return this._pause_options
  }

  get loading() {
    return this._loading
  }

  setLoading = (value: boolean) => {
    this._loading = value
  }
}
